module.exports = __webpack_public_path__ + "static/media/visa.04d92ba2.svg";